import {
  ELSRestClientHelper,
  ELSCommonConfig,
  ELSTokenHelper,
  ELSLoggingService
} from '@els/els-ui-common-react';
import { AxiosResponse } from 'axios';

const fileName = 'api.utilities';

export const buildUrlFromBase = (
  url: string,
  addBaseUrl = true,
  includeApiPath = true
): string => {
  if (!addBaseUrl) {
    return url;
  }
  if (!includeApiPath) {
    return `${ELSCommonConfig.buildUrl}${url}`;
  }
  return `${ELSCommonConfig.buildUrl}/api${url}`;
};


const withApiErrorLoggingOnly = <T>(promiseFunction: () => Promise<AxiosResponse<T>>): Promise<T> =>
  promiseFunction()
    .then(res => res.data)
    .catch((error: Error) => {
      // https://github.com/elsevierPTG/els-ui-common-react/blob/develop/module/services/LoggingService.js
      ELSLoggingService.error(fileName, error.message, error);
      throw error;
    });

export const getDefaultRequestHeaders = (headers = {}): Record<string, string> => {
  return {
    Authorization: `Bearer ${ELSTokenHelper.getToken()}`,
    accept: 'application/json, text/plain, */*',
    ...headers
  };
};

export const getDefaultRequestOptions = (options = {}, headers = {}): Record<string, unknown> => {
  return {
    headers: getDefaultRequestHeaders(headers),
    useWithCredentials: false,  // Default to not sending cookies
    ...options,  // options can override useWithCredentials if needed
  };
};

enum RestCall {
  get = 'get',
  post = 'post',
  put = 'put',
  patch = 'patch',
  delete = 'delete',
}

export type eolsBaseApiType = Record<
  RestCall,

  <T>(
    url: string,
    options?: unknown,
    headers?: unknown,
    addBaseUrl?: boolean,
    includeApiPath?: boolean
  ) => Promise<AxiosResponse<T>>
>

const eolsBaseApi: eolsBaseApiType = Object.values(RestCall).reduce((acc, cur) => {
  return {
    ...acc,
    [cur]: (
      url,
      options = {},
      headers = {},
      addBaseUrl = true,
      includeApiPath = true,
    ) => {
      return ELSRestClientHelper[cur](buildUrlFromBase(url, addBaseUrl, includeApiPath), getDefaultRequestOptions(options, headers));
    },
  };
}, {} as eolsBaseApiType);

export {
  withApiErrorLoggingOnly,
  eolsBaseApi
};
